import { motion } from 'framer-motion';
import { Flex, Heading } from '@podiumhq/design-system';

import { getHeading, getComponent } from './utils';
import { useTrialsContext } from 'contexts/TrialsContextProvider';

const SignUpPageAnimations = () => {
  const { trialPageVariantSlug } = useTrialsContext();

  return (
    <Flex
      bg="black.base"
      width="50%"
      color="silver.lightest"
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      overflow="hidden"
    >
      <Flex
        maxWidth="500px"
        width="80%"
        flexDir="column"
        alignItems="center"
        justifyContent="center"
      >
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
        >
          <Heading textAlign="center" fontSize="2xl" w="346px">
            {getHeading(trialPageVariantSlug)}
          </Heading>
        </motion.div>
        <Flex
          position="relative"
          width="100%"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
        >
          {getComponent(trialPageVariantSlug)}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default SignUpPageAnimations;
